import React from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import SideNavBar from './SideNavBar';
import { Switch } from 'react-router-dom';
import {
  ATHENEUM_ANALYTICS_MODULE_ROUTE,
  ATHENEUM_COURSES_MODULE_ROUTE,
  ATHENEUM_PROGRAMS_MODULE_ROUTE,
  ATHENEUM_ROUTE_PREFIX,
  ATHENEUM_QUERY_MODULE_ROUTE,
  ATHENEUM_USER_MODULE_ROUTE,
  ATHENEUM_ORDERS_MODULE_ROUTE,
  ATHENEUM_WISHLIST_MODULE_ROUTE,
  ATHENEUM_CART_MODULE_ROUTE,
  ATHENEUM_OFFER_MODULE_ROUTE,
  ATHENEUM_CERTIFICATION_MODULE_ROUTE,
} from '../../routes/routes';
import Program from './Programs';
import Course from './Courses';
import Query from './Query';
import User from './User';
import Orders from './Orders';
import Wishlist from './Wishlist';
import Cart from './Cart';
import Offer from './Offer';
import Certification from './Certification';
// import useToggleSideNav from '../../hooks/useToggleSideNav';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

function Atheneum() {
  const classes = useStyles();

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">Atheneum</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Managing Atheneum
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10}>
        <Box minWidth={300} pt={4}>
          <SideNavBar />
        </Box>
        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={ATHENEUM_ROUTE_PREFIX}
              component={() => (
                <h1>
                  Hello Atheneum User - we are analytics module, to come soon!
                </h1>
              )}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_ANALYTICS_MODULE_ROUTE]}
              component={() => (
                <h1>
                  Hello Atheneum User - we are analytics module, to come soon!
                </h1>
              )}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_PROGRAMS_MODULE_ROUTE]}
              component={Program}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_COURSES_MODULE_ROUTE]}
              component={Course}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_QUERY_MODULE_ROUTE]}
              component={Query}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_USER_MODULE_ROUTE]}
              component={User}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_ORDERS_MODULE_ROUTE]}
              component={Orders}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_WISHLIST_MODULE_ROUTE]}
              component={Wishlist}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_CART_MODULE_ROUTE]}
              component={Cart}
            />
            <PrivateRoute
              exact
              path={[ATHENEUM_ROUTE_PREFIX, ATHENEUM_OFFER_MODULE_ROUTE]}
              component={Offer}
            />
            <PrivateRoute
              exact
              path={[
                ATHENEUM_ROUTE_PREFIX,
                ATHENEUM_CERTIFICATION_MODULE_ROUTE,
              ]}
              component={Certification}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default Atheneum;
